
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'clp-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [
        TranslateModule
    ]
})

export class ToolbarComponent  {
    @Input() title!:string;
}
